// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;Some put their trust in chariots and some in horses,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;but we will call only on the name of the Lord our God.<br> </p> </div></div>";
// Exports
module.exports = code;